(function ($) {
    $('.js-language-selector').on('click', function () {
        $('.js-language-tab').toggleClass('language-tab-active')
    });
})(jQuery);